module.exports = __webpack_public_path__ + "static/img/the-last-jedi.6cf7a35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posters/the-last-jedi.jpg
// module id = baVL
// module chunks = 0